import React from "react";

const InitiatedChat = () => {
  return <div>Initiated</div>;
};

export default InitiatedChat;
